<template>
  <div class="d-flex flex-column" id="app">
    <vue-progress-bar></vue-progress-bar>
    <topo logoURL="/imgs/brasao-pbh.png" logoSmallURL="https://assets.pbh.gov.br/assets/pbh/images/logo-pbh-cor-pos.svg"
      sigla="Cesta Estudantes" homeLink="/" :showMenu="$store.getters.isAuthenticated" :usuario="usuario"
      :itensMenu="itens_menu" :logout-callback="logout" :ambiente="ambiente"></topo>
    <b-overlay :show="$store.getters.loading" rounded="sm">
      <template #overlay>
        <div class="text-center">
          <b-spinner>
            <b-icon icon="star-fill"></b-icon>
          </b-spinner>
          <p v-if="$store.getters.flagMsgLoading">
            {{ $store.getters.msgLoading }}
          </p>
        </div>
      </template>
      <div class="container" id="content">
        <router-view></router-view>
      </div>
    </b-overlay>
    <piweb-rodape :versao="versao"
      logoURL="https://assets.pbh.gov.br/assets/pbh/images/logo-pbh-cor-pos.svg"></piweb-rodape>
  </div>
</template>

<script>
import helpers from "../helpers";
import piwebRodape from "../components/layout/piweb-rodape.vue";

export default {
  components: {
    topo: require("../components/layout/TopoCustom.vue").default,
    piwebRodape,
  },
  computed: {
    sigla() {
      return this.$env.VUE_APP_SIGLA || "";
    },
    ambiente() {
      return this.$env.VUE_APP_AMBIENTE;
    },
    versao() {
      return this.$store.getters.const.sistema.versao || "";
    },
    usuario() {
      return { name: this.$store.getters.userInfo.name };
    },
    itens_menu() {
      let itens = [{ titulo: "Home", to: { name: "home", path: "/" } }];
      if (this.can("admin")) {
        itens.push({
          titulo: "Admin",
          itens: [
            {
              titulo: "Gerenciar beneficiário",
              to: {
                name: "admin",
                path: "/admin",
              },
            },
            {
              titulo: "Gerenciar dados de retirada",
              to: {
                name: "edicao_flag_retirado",
                path: "/admin/editar-retirado",
              },
            },
            {
              titulo: "Históricos",
              to: { name: "historico", path: "/admin/historico" },
            },
            {
              titulo: "Criar Voucher Famílias",
              to: {
                name: "criar-voucher-familias",
                path: "/admin/criar-voucher-familias",
              },
            },
            {
              titulo: "Gerenciar Vouchers Retirados",
              to: {
                name: "gerenciar-voucher-retirado",
                path: "/admin/gerenciar-voucher-retirado",
              },
            },
          ],
        });
      }
      if (this.can("importacao-familias")) {
        itens.push({
          titulo: "Importação",
          itens: [
            {
              titulo: "Importar famílias",
              to: {
                name: "importacao-familias",
                path: "/admin/importacao-familias",
              },
            },
            {
              titulo: "Importação do retorno do mercado",
              to: {
                name: "importacao-mercados",
                path: "/admin/importacao-mercados",
              },
            },
          ],
        });
        itens.push({
          titulo: "Exportação",
          itens: [
            {
              titulo: "Exportar Dados SMED",
              to: {
                name: "exportacao-dados-cesta-smed",
                path: "/exportacao/dados-cesta-smed",
              },
            },
            {
              titulo: "Exportar Dados Mercado",
              to: {
                name: "exportacao-dados-cesta-mercado",
                path: "/exportacao/dados-cesta-mercado",
              },
            },
          ],
        });
      }
      if (this.can("params")) {
        itens.push({
          titulo: "Parâmetros",
          itens: [
            {
              titulo: "Parâmetros",
              to: { name: "list_params", path: "/admin/lista-params" },
            },
            {
              titulo: "Inativar Famílias",
              to: {
                name: "inativar_familias",
                path: "/admin/inativar-familias",
              },
            },
            {
              titulo: "Mensagem Tela Inicial",
              to: {
                name: "mensagem-tela-inicial",
                path: "/admin/mensagem-tela-inicial",
              },
            },
          ],
        });
      }
      if (this.can("estudades_escola_regional")) {
        itens.push({
          titulo: "Relatórios",
          itens: [
            {
              titulo: "Estudantes por Escola x Regional",
              to: {
                name: "estudades_escola_regional",
                path: "/relatorio/estudades-por-escola-regional",
              },
            },
            {
              titulo: "Cestas por Tipo x Escola x Fornecedor x Regional",
              to: {
                name: "cestas_por_tipo_escola_for_regional",
                path: "/relatorio/cestas_por_tipo_escola_for_regional",
              },
            },
            {
              titulo: "Inconsistências Importação Arquivo Mercado",
              to: {
                name: "import_mercado_erros",
                path: "/relatorio/import_mercado_erros",
              },
            },
            {
              titulo: "Beneficiários x Voucher Cancelado",
              to: {
                name: "voucher_cancelado",
                path: "/relatorio/voucher_cancelado",
              },
            },
            {
              titulo: "Vouchers Visualizados",
              to: {
                name: "voucher_visualizado",
                path: "/relatorio/voucher_visualizado",
              },
            },
            {
              titulo: "Vouchers Visualizados/Não Visualizados - Dados",
              to: {
                name: "voucher_visualizado_familia",
                path: "/relatorio/voucher_visualizado_familia",
              },
            },
            {
              titulo: "Vouchers Retirados",
              to: {
                name: "voucher_retirado",
                path: "/relatorio/voucher_retirado",
              },
            },
            {
              titulo: "Dados Gerais da Edição",
              to: {
                name: "dados_gerais_edicao",
                path: "/relatorio/dados_gerais_edicao",
              },
            },
            {
              titulo: "Dados dos Vouchers Visualizados",
              to: {
                name: "visualizados_retirados_nao_retirados",
                path: "/relatorio/visualizados_retirados_nao_retirados",
              },
            },
            {
              titulo: "Dados dos Vouchers Não Visualizados",
              to: {
                name: "nao_visualizados_retirados_nao_retirados",
                path: "/relatorio/nao_visualizados_retirados_nao_retirados",
              },
            },
          ],
        });
      }
      return itens;
    },
  },
  methods: {
    logout() {
      return this.$store.dispatch("LOGOUT_REQUEST");
    },
    setGoogleAnalytics() {
      helpers.getEnv().then((response) => {
        const googleAnalyticsId = response.VUE_APP_GOOGLE_ANALYTICS_ID;

        if (googleAnalyticsId) {
          const scriptGTM1 = window.document.createElement("script");
          scriptGTM1.setAttribute("async", "");
          scriptGTM1.setAttribute(
            "src",
            `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`
          );
          window.document.head.appendChild(scriptGTM1);

          const scriptGTM2 = window.document.createElement("script");
          scriptGTM2.innerText = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${googleAnalyticsId}');`;
          window.document.head.appendChild(scriptGTM2);
        }
      });
    },
  },
  mounted() {
    this.$Progress.finish();
    this.setGoogleAnalytics();
  },
  created() {
    this.$Progress.start();

    this.$router.beforeEach((to, from, next) => {
      this.$Progress.start();
      this.$store.commit("setLoading", true);
      next();
    });

    this.$router.afterEach(() => {
      this.$store.commit("setLoading", false);
      this.$Progress.finish();
    });
  },
};
</script>
<style>
#content.container {
  min-height: 82vh;
}
</style>
